import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { Link } from "react-router-dom";
import logo from "../assets/ALTAIR-01.png";
import partner1 from "../assets/PARTNERS_LOGO/ctecfav.png";
import partner2 from "../assets/PARTNERS_LOGO/Ethiopian_Airlines_Logo.svg.png";
import partner3 from "../assets/PARTNERS_LOGO/images.png";
import partner4 from "../assets/PARTNERS_LOGO/logo_LIQUID.png";
import partner5 from "../assets/PARTNERS_LOGO/Schneider-Electric-logo-jpg_16-9_white.png";
import partner6 from "../assets/PARTNERS_LOGO/Techno-Switch.png";
import partner7 from "../assets/PARTNERS_LOGO/Yas_Tanzania.svg-4.png";

const partners = [partner1, partner2, partner3, partner4, partner5, partner6, partner7];

function Footer() {
  return (
    <footer className="bg-gray-50 text-black pt-10 pb-6 px-4 relative">

      <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4  gap-8 px-4 sm:px-6 lg:px-8 mt-1">
        {/* Logo, Description & Social */}
        <div className="flex flex-col items-start">
          <img src={logo} alt="Altair Logo" className="h-10 mb-4" />
          <p className="text-sm text-gray-700 mb-4">
            Altair delivers innovative engineering, construction, and technology solutions for a smarter future.
          </p>
          <div className="flex gap-4 mb-2">
            <a href="https://www.facebook.com/share/178CfniKeP/?mibextid=wwXIfr" aria-label="Facebook" className="hover:text-[#FF6B00]"><FaFacebookF /></a>
            <a href="https://www.linkedin.com/company/altair-company-ltd/" aria-label="LinkedIn" className="hover:text-[#FF6B00]"><FaLinkedinIn /></a>
            <a href="https://www.instagram.com/altair_co_ltd?igsh=MW0yZWI5dHpxZ2kzdw%3D%3D&utm_source=qr" aria-label="Instagram" className="hover:text-[#FF6B00]"><FaInstagram /></a>
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="font-semibold mb-3 text-[#FF6B00]">Quick Links</h4>
          <ul className="space-y-2">
            <li><Link to="/" className="hover:text-[#FF6B00] transition">Home</Link></li>
            <li><Link to="/about" className="hover:text-[#FF6B00] transition">About Us</Link></li>
            <li><Link to="/projects" className="hover:text-[#FF6B00] transition">Projects</Link></li>
            <li><Link to="/contact" className="hover:text-[#FF6B00] transition">Contact</Link></li>
          </ul>
        </div>

        {/* Services Links */}
        <div>
          <h4 className="font-semibold mb-3 text-[#FF6B00]">Our Services</h4>
          <ul className="space-y-2">
            <li><Link to="/construction" className="hover:text-[#FF6B00] transition">Construction & Civil Works</Link></li>
            <li><Link to="/ict" className="hover:text-[#FF6B00] transition">ICT & IoT Services</Link></li>
            <li><Link to="/electrical" className="hover:text-[#FF6B00] transition">Electrical Services</Link></li>
            <li><Link to="/fire" className="hover:text-[#FF6B00] transition">Fire Systems</Link></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h4 className="font-semibold mb-3 text-[#FF6B00]">Contact</h4>
          <ul className="space-y-2 text-sm">
            <li>Email: <a href="mailto:info@altair.com" className="hover:text-[#FF6B00] transition">info@altair.co.tz</a></li>
            <li>Phone: <a href="tel:+1234567890" className="hover:text-[#FF6B00] transition">+255714183424</a></li>
            <li>Location: Simba Oil, Goba</li>
            <li>Dar es salaam, Tanzania</li>
          </ul>
        </div>
      </div>

      {/* Second row */}
      <div className="max-w-7xl mx-auto items-center justify-center mt-10 border-t pt-4 px-4 text-xs text-gray-500">
        <div className="mb-2 md:mb-0 text-center">&copy; {new Date().getFullYear()} Altair. All rights reserved.</div>
      </div>
    </footer>
  );
}

export default Footer;
